// 设置运行时公共路径为主题 assets 基准（来自 全局 JS 变量 注入）
const jdsBase = typeof window !== 'undefined' && window.pageInfo ? window.pageInfo.__webpack_public_path__ : undefined;

try {
  if (typeof jdsBase === 'string' && jdsBase) {
    // 兼容普通脚本构建
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = jdsBase;

    // 兼容 Webpack 5 在 ESM / module 场景下的公共路径解析
    // eslint-disable-next-line no-undef
    if (typeof __webpack_base_uri__ !== 'undefined') {
      // eslint-disable-next-line no-undef
      __webpack_base_uri__ = jdsBase;
    }

    // 兜底：直接覆盖运行时的 publicPath
    // eslint-disable-next-line no-undef
    if (typeof __webpack_require__ !== 'undefined' && __webpack_require__.p !== jdsBase) {
      // eslint-disable-next-line no-undef
      __webpack_require__.p = jdsBase;
    }
  }
} catch (e) {
  // 忽略运行时环境中未声明的变量导致的异常
}

// 引入Jackery Design System 设计系统
import '@jackery/design-system'